module.exports = __webpack_public_path__ + "static/img/第十九届.3886e78.png";


//////////////////
// WEBPACK FOOTER
// ./static/20260620/past/第十九届.png
// module id = ZeUZ
// module chunks = 1